import React from "react";
import { useTranslation } from "react-i18next";
import CustomDialog from "../../../components/modals/CustomDialog/CustomDialog";

export default function TeamViewModal({ isOpen, team, onClose }) {
  const [t] = useTranslation();

  if (!team) return null;

  const supervisor = team.team_members?.find(
    (member) => member.role === "SUPERVISOR"
  );
  const participants = team.team_members?.filter(
    (member) => member.role !== "SUPERVISOR"
  );

  return (
    <CustomDialog
      isOpen={isOpen}
      headerText={team.name || t("admin.team_name")}
      closeModal={onClose}
    >
      <div className="flex flex-col gap-4">
        <div>
          <h3 className="font-semibold mb-2">{t("team.supervisor")}</h3>
          {supervisor ? (
            <div className="bg-gray-50 p-3 rounded-md">
              <p>
                <span className="font-medium">{t("signup.name")}:</span>{" "}
                {supervisor.user?.first_name} {supervisor.user?.last_name}{" "}
                {supervisor.user?.middle_name}
              </p>
              <p>
                <span className="font-medium">{t("student.email")}:</span>{" "}
                {supervisor.user?.email || "-"}
              </p>
              <p>
                <span className="font-medium">{t("signup.phone_number")}:</span>{" "}
                {supervisor.user?.phone_number || "-"}
              </p>
              <p>
                <span className="font-medium">{t("signup.gender")}:</span>{" "}
                {supervisor.user?.gender === "M"
                  ? t("signup.male")
                  : t("signup.female")}
              </p>
            </div>
          ) : (
            <p className="text-gray-500">-</p>
          )}
        </div>

        <div>
          <h3 className="font-semibold mb-2">{t("team.members")}</h3>
          {participants && participants.length > 0 ? (
            <div className="space-y-2">
              {participants.map((member, index) => (
                <div
                  key={member.uuid || index}
                  className="bg-gray-50 p-3 rounded-md"
                >
                  <p>
                    <span className="font-medium">{t("signup.name")}:</span>{" "}
                    {member.user?.first_name} {member.user?.last_name}{" "}
                    {member.user?.middle_name}
                  </p>
                  <p>
                    <span className="font-medium">{t("student.email")}:</span>{" "}
                    {member.user?.email || "-"}
                  </p>
                  <p>
                    <span className="font-medium">
                      {t("signup.phone_number")}:
                    </span>{" "}
                    {member.user?.phone_number || "-"}
                  </p>
                  {/* <p>
                    <span className="font-medium">
                      {t("signup.study_lang")}:
                    </span>{" "}
                    {member.user?.language === "K"
                      ? "Қазақша"
                      : member.user?.language === "R"
                      ? "Русский"
                      : member.user?.language}
                  </p> */}
                  <p>
                    <span className="font-medium">{t("team.grade")}:</span>{" "}
                    {t("team.grade_option", {
                      value: member.user?.grade,
                    })}
                  </p>
                  <p>
                    <span className="font-medium">{t("signup.gender")}:</span>{" "}
                    {member.user?.gender === "M"
                      ? t("signup.male")
                      : t("signup.female")}
                  </p>
                  {/* <p>
                    <span className="font-medium">{t("team.role")}:</span>{" "}
                    {member.role || "-"}
                  </p> */}
                </div>
              ))}
            </div>
          ) : (
            <p className="text-gray-500">{t("team.no_members")}</p>
          )}
        </div>
      </div>
    </CustomDialog>
  );
}
